"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MystakeAddressSchema = exports.UpdatePasswordSchema = exports.InviteNomineeSchema = exports.DobAddressSchema = exports.AddCompanySchema = exports.CreateAccountSchema = exports.UserSchema = exports.ExternalUserSchema = exports.LoginSchema = exports.ACN_REGEX = exports.E_164_PHONE_REGEX = exports.REQUIRED_FIELD_MESSAGE = void 0;
const yup = __importStar(require("yup"));
const fp_1 = require("date-fns/fp");
const set_1 = __importDefault(require("date-fns/set"));
exports.REQUIRED_FIELD_MESSAGE = "This is a required field.";
exports.E_164_PHONE_REGEX = new RegExp(/^\+[1-9]\d{1,14}$/);
exports.ACN_REGEX = new RegExp(/^\d{9}$/);
const currentDate = [(0, set_1.default)(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })]
    .map((0, fp_1.subYears)(18))
    .map((0, fp_1.addDays)(1))[0];
const minDate = [(0, set_1.default)(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })].map((0, fp_1.subYears)(153))[0];
const createAccount = {
    salutation: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .oneOf(["", "Mr", "Mrs", "Miss", "Ms", "Dr"]),
    firstName: yup
        .string()
        .trim()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .min(1, "First name must be at least 1 character")
        .max(20, "First name must be at most 20 characters"),
    secondName: yup.string().max(20, "Middle names must be at most 20 characters").nullable(true).trim(),
    thirdName: yup.string().max(20, "Middle names must be at most 20 characters").nullable(true).trim(),
    familyName: yup
        .string()
        .trim()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .min(2, "Last name must be at least 2 characters")
        .max(30, "Last name must be at most 30 characters"),
    email: yup.string().email().required(exports.REQUIRED_FIELD_MESSAGE).max(255),
    password: yup
        .string()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .min(12)
        .max(255)
        .test("no spaces in password", "Spaces not allowed in password", (password) => /^[\S]+$/.test(password))
        .test("lower case in password", "Password must contain at least one lowercase letter", (password) => /[a-z]/.test(password))
        .test("upper case in password", "Password must contain at least one uppercase letter", (password) => /[A-Z]/.test(password))
        .test("number in password", "Password must contain at least one number", (password) => /[0-9]/.test(password))
        .test("special character in password", "Password must contain at least one special character", (password) => /[\^$*.[\]{}()?\-"!@#%&/,><':;|_~`]/.test(password)),
    confirmPassword: yup
        .string()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .oneOf([yup.ref("password")], "Passwords do not match"),
    dialCode: yup
        .string()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .matches(/^\+[1-9]\d{0,3}$/, "Invalid dial code"),
    phoneNumber: yup
        .string()
        .trim()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .matches(/^\d{1,14}$/, "Phone Number can only contain digits, at most 14 digits are allowed"),
    tncAccepted: yup
        .boolean()
        .oneOf([true], "Must accept terms & conditions and privacy policy")
        .required("Must accept terms & conditions and privacy policy"),
};
exports.CreateAccountSchema = createAccount;
const addCompany = {
    acn: yup.string().trim().required(exports.REQUIRED_FIELD_MESSAGE).matches(exports.ACN_REGEX, "ACN should be exact 9 digits long"),
    companyName: yup
        .string()
        .trim()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .min(1, "Company name must be at least 1 characters")
        .max(255, "Company name must be at most 255 characters"),
    companyType: yup
        .string()
        .trim()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .oneOf(["Private Company", "Public Company", "Trustee Company", "SMSF"], "Company Type must be one of the following values: Private Company, Public Company, Trustee Company, SMSF"),
    tncAccepted: yup
        .boolean()
        .oneOf([true], "Must accept terms & conditions and privacy policy")
        .required("Must accept terms & conditions and privacy policy"),
};
exports.AddCompanySchema = addCompany;
const schema = Object.assign({ dob: yup
        .date()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .typeError("Invalid date")
        .max(currentDate, `dob field must be earlier than ${currentDate.toDateString()}`)
        .min(minDate, `dob field must be later than ${minDate.toDateString()}`), salutation: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .oneOf(["", "Mr", "Mrs", "Miss", "Ms", "Dr"]), firstName: yup
        .string()
        .trim()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .min(1, "First name must be at least 1 character")
        .max(20, "First name must be at most 20 characters"), secondName: yup.string().max(20, "Middle names must be at most 20 characters").nullable(true).trim(), thirdName: yup.string().max(20, "Middle names must be at most 20 characters").nullable(true).trim(), familyName: yup
        .string()
        .trim()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .min(2, "Last name must be at least 2 characters")
        .max(30, "Last name must be at most 30 characters"), email: yup.string().email().required(exports.REQUIRED_FIELD_MESSAGE).max(255), password: yup
        .string()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .min(12)
        .max(255)
        .test("no spaces in password", "Spaces not allowed in password", (password) => /^[\S]+$/.test(password))
        .test("lower case in password", "Password must contain at least one lowercase letter", (password) => /[a-z]/.test(password))
        .test("upper case in password", "Password must contain at least one uppercase letter", (password) => /[A-Z]/.test(password))
        .test("number in password", "Password must contain at least one number", (password) => /[0-9]/.test(password))
        .test("special character in password", "Password must contain at least one special character", (password) => /[\^$*.[\]{}()?\-"!@#%&/,><':;|_~`]/.test(password)), confirmPassword: yup
        .string()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .oneOf([yup.ref("password")], "Passwords do not match"), dialCode: yup
        .string()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .matches(/^\+[1-9]\d{0,3}$/, "Invalid dial code"), phoneNumber: yup
        .string()
        .trim()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .matches(/^\d{1,14}$/, "Phone Number can only contain digits, at most 14 digits are allowed") }, addCompany);
exports.UserSchema = schema;
exports.LoginSchema = yup.object().shape({
    username: yup.string().trim().required("User ID or email is required"),
    password: yup.string().trim().required("Password is required"),
});
exports.ExternalUserSchema = yup.object().shape({
    username: yup.string().trim().required("User ID or email is required"),
    email: yup.string().trim().required("Email is required"),
    firstName: yup.string().trim().required("First name is required"),
    familyName: yup.string().trim().required("Family name is required"),
});
const dobAddressSchema = yup.object().shape({
    dob: schema.dob,
    flatNumber: yup.string().trim().max(255),
    streetNumber: yup.string().trim().max(255),
    propertyName: yup.string().trim().max(255),
    streetName: yup.string().trim().max(255),
    streetType: yup.string().trim().max(255),
    suburb: yup.string().trim().max(255),
    townCity: yup.string().trim().max(255),
    city: yup.string().trim().max(255),
    postcode: yup.string().trim(),
    state: yup
        .string()
        .trim()
        .when("country", {
        is: "AU",
        then: yup.string().oneOf(["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"]).required(exports.REQUIRED_FIELD_MESSAGE),
        otherwise: yup.string().max(100),
    }),
    country: yup
        .string()
        .trim()
        .matches(/^[a-zA-Z]{2}$/, "Country should be 2-letter ISO code")
        .required(exports.REQUIRED_FIELD_MESSAGE),
});
exports.DobAddressSchema = dobAddressSchema;
const inviteNomineeSchema = yup.object().shape({
    salutation: yup.string().oneOf(["", "Mr", "Mrs", "Miss", "Ms", "Dr"]),
    firstName: schema.firstName,
    secondName: schema.secondName,
    thirdName: schema.thirdName,
    familyName: schema.familyName,
    email: yup.string().email().required(exports.REQUIRED_FIELD_MESSAGE).max(255),
    dialCode: yup
        .string()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .matches(/^\+[1-9]\d{0,3}$/, "Invalid dial code"),
    phoneNumber: yup
        .string()
        .trim()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .matches(/^\d{1,14}$/, "Phone Number can only contain digits, at most 14 digits are allowed"),
});
exports.InviteNomineeSchema = inviteNomineeSchema;
const updatePasswordSchema = yup.object().shape({
    currentPassword: yup.string().required("Please enter your current password").label("Current password"),
    newPassword: schema.password
        .label("New password")
        .test("notCurrentPassword", "New password shouldn't match current password", function (password) {
        return password !== this.parent.currentPassword;
    }),
    confirmPassword: yup
        .string()
        .required(exports.REQUIRED_FIELD_MESSAGE)
        .oneOf([yup.ref("newPassword")], "Passwords do not match")
        .label("Confirm password"),
});
exports.UpdatePasswordSchema = updatePasswordSchema;
const mystakeAddressSchema = yup.object().shape({
    careOf: yup.string().trim().min(0).max(50).ensure(),
    unitNumber: yup.string().trim().min(0).max(50).ensure(),
    streetName: yup.string().trim().required("Please enter Street name and number or PO Box").min(1).max(52),
    suburb: yup.string().trim().required("Please enter Suburb").min(2).max(30),
    state: yup
        .string()
        .trim()
        .required("Please enter State")
        .test("length-3-if-country-is-australia", "state must be 3 characters long", 
    // eslint-disable-next-line func-names
    function (value) {
        const { country } = this.parent;
        if (country === "Australia" && ((value === null || value === void 0 ? void 0 : value.length) > 3 || (value === null || value === void 0 ? void 0 : value.length) < 2)) {
            return false;
        }
        return true;
    })
        .test("length-if-country-not-australia", "state must be 2-30 characters long", 
    // eslint-disable-next-line func-names
    function (value) {
        const { country } = this.parent;
        if (country === "Australia" && ((value === null || value === void 0 ? void 0 : value.length) > 30 || (value === null || value === void 0 ? void 0 : value.length) < 2)) {
            return false;
        }
        return true;
    }),
    postcode: yup
        .string()
        .trim()
        .required("Please enter Post Code")
        .test("length-4-if-country-is-australia", "postcode must be 4 characters long", 
    // eslint-disable-next-line func-names
    function (value) {
        const { country } = this.parent;
        if (country === "Australia" && (value === null || value === void 0 ? void 0 : value.length) !== 4) {
            return false;
        }
        return true;
    })
        .test("length-if-country-not-australia", "postcode must be 1-10 characters long", 
    // eslint-disable-next-line func-names
    function (value) {
        const { country } = this.parent;
        if (country !== "Australia" && (value === null || value === void 0 ? void 0 : value.length) > 10) {
            return false;
        }
        return true;
    }),
    country: yup.string().trim().required("Please enter Country").min(1).max(30),
});
exports.MystakeAddressSchema = mystakeAddressSchema;
//# sourceMappingURL=User.js.map